export default "__VITE_ASSET__sOuTamRU__"